import {
  laravelGet,
  laravelPost,
  laravelPut,
  laravelDelete,
  laravelRequest,
} from '../utils/laravelClient';
import { createQueryString } from '../utils/apiUtils';

export async function fetchMe() {
  return laravelGet('/auth/me', {
    auth: 'admin',
    context: { redirectOnFailure: false },
  });
}

export async function loginUser({ email, password }) {
  return laravelPost('/auth/login', { email, password }, { auth: 'none' });
}

export async function createUser(userData) {
  return laravelPost('/auth/register', userData, { auth: 'admin' });
}

export async function getAllUsers(params = {}) {
  const qs = createQueryString(params);
  const path = qs ? `/users?${qs}` : '/users';
  return laravelRequest('GET', path, { auth: 'admin' });
}

export async function updateUser(userId, userData) {
  return laravelPut(`/users/${userId}`, userData, { auth: 'admin' });
}

export async function deleteUser(userId) {
  return laravelDelete(`/users/${userId}`, { auth: 'admin' });
}

export async function resetUserPassword(userId, { password, password_confirmation }) {
  return laravelPost(
    `/users/${userId}/reset-password`,
    { password, password_confirmation },
    { auth: 'admin' }
  );
}
